import { render, staticRenderFns } from "./SimpleOrderPerformanceTable.vue?vue&type=template&id=086b90d2&scoped=true"
import script from "./SimpleOrderPerformanceTable.vue?vue&type=script&lang=js"
export * from "./SimpleOrderPerformanceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086b90d2",
  null
  
)

export default component.exports